import React from 'react'
import { Loader } from '@googlemaps/js-api-loader';

export default function GoogleMap(props) {
    React.useEffect(()=> {
        const loader = new Loader({
            apiKey: props.apiKey,
            version: "weekly",
            libraries: ["places"]
          });

        loader
            .load()
            .then((google) => {
                props.callback(google);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);
    return (
        <div id="map"></div>
    );
}